module.exports = __webpack_public_path__ + "static/media/railcarListing.1b5ef754.svg";